// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsBom3-Bom3Positions-cellComponents-Cell2ColorModel-Cell2ColorModel-module__cell--X9NIJ {
  flex: 1;
  display: flex;
  flex-direction: row;
  gap: 4px;
}
.src-businessServices-services-bsBom3-Bom3Positions-cellComponents-Cell2ColorModel-Cell2ColorModel-module__info--n1hHt {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.src-businessServices-services-bsBom3-Bom3Positions-cellComponents-Cell2ColorModel-Cell2ColorModel-module__colorValue--Xd8Q_ {
  width: 70px;
  height: 40px;
  border: thin solid #888;
}
.src-businessServices-services-bsBom3-Bom3Positions-cellComponents-Cell2ColorModel-Cell2ColorModel-module__imageValue--baHe8 {
  max-width: 70px;
  max-height: 40px;
  border: thin solid #888;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsBom3/Bom3Positions/cellComponents/Cell2ColorModel/Cell2ColorModel.module.less"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AACF;AAEA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAAF;AAKA;EACE,WAAA;EACA,YAAA;EACA,uBAAA;AAHF;AAMA;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;AAJF","sourcesContent":[".cell {\n  flex: 1;\n  display: flex;\n  flex-direction: row;\n  gap: 4px;\n}\n\n.info {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n@imgBorder: thin solid #888;\n\n.colorValue {\n  width: 70px;\n  height: 40px;\n  border: @imgBorder;\n}\n\n.imageValue {\n  max-width: 70px;\n  max-height: 40px;\n  border: @imgBorder;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cell": `src-businessServices-services-bsBom3-Bom3Positions-cellComponents-Cell2ColorModel-Cell2ColorModel-module__cell--X9NIJ`,
	"info": `src-businessServices-services-bsBom3-Bom3Positions-cellComponents-Cell2ColorModel-Cell2ColorModel-module__info--n1hHt`,
	"colorValue": `src-businessServices-services-bsBom3-Bom3Positions-cellComponents-Cell2ColorModel-Cell2ColorModel-module__colorValue--Xd8Q_`,
	"imageValue": `src-businessServices-services-bsBom3-Bom3Positions-cellComponents-Cell2ColorModel-Cell2ColorModel-module__imageValue--baHe8`
};
export default ___CSS_LOADER_EXPORT___;
